import { useEffect } from "react";
import { withRouterUtilities } from "../util/withRouterUtilities";
import { withDataMapping } from "../util/hocs/withDataMapping";

const RedirectIfMissing = ({
  navigate,
  redirectUrl,
  fieldName,
  data,
  children,
}) => {
  useEffect(() => {
    if (!data?.[fieldName]) {
      navigate(redirectUrl);
    }
  }, []);
  return children;
};

export default withRouterUtilities(withDataMapping(RedirectIfMissing));
